import { useEffect, useState } from "react";
import { ShieldCheck, Loader2, ArrowLeft } from "lucide-react";
import { api, apiError } from "@/lib/api";

export const OtpStep = ({ otp, onVerify, onBack }) => {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);
  const [wait, setWait] = useState(60);
  useEffect(() => { if (wait <= 0) return; const t = setTimeout(() => setWait(wait - 1), 1000); return () => clearTimeout(t); }, [wait]);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(""); setInfo("");
    try { await onVerify(code); }
    catch (ex) { setErr(apiError(ex, "Código inválido.")); setCode(""); }
    setBusy(false);
  };
  const resend = async () => {
    setErr(""); setInfo("");
    try { await api.post("/auth/resend", { challenge: otp.challenge }); setInfo("Novo código enviado."); setWait(60); }
    catch (ex) { setErr(apiError(ex, "Não foi possível reenviar.")); }
  };
  return (
    <form data-testid="otp-step" onSubmit={submit}>
      <div className="mb-5 flex items-start gap-3 rounded-xl border border-sky-500/25 bg-sky-500/[0.07] p-3">
        <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-sky-300" />
        <p data-testid="otp-sent-to" className="text-xs leading-relaxed text-slate-300">
          Enviamos um código de 6 dígitos para <b className="text-white">{otp.sent_to}</b>. Ele vale {otp.expires_min} minutos.
        </p>
      </div>
      <label className="text-xs font-medium text-slate-400">Código de verificação</label>
      <input data-testid="otp-code" autoFocus inputMode="numeric" autoComplete="one-time-code" maxLength={6} required
        value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
        className="mt-1 w-full rounded-xl border border-[#1F293D] bg-[#0B0F17] py-3 text-center font-mono text-2xl tracking-[0.5em] text-white outline-none transition-colors focus:border-sky-500" />
      <p className="mt-2 text-[11px] text-slate-500">Este navegador ficará confiável por 7 dias.</p>
      {err && <div data-testid="otp-error" className="mt-4 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-300">{err}</div>}
      {info && <div data-testid="otp-info" className="mt-4 rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-xs text-emerald-300">{info}</div>}
      <button data-testid="otp-submit" disabled={busy || code.length !== 6} className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-sky-500 py-3 text-sm font-bold text-slate-950 transition-transform hover:-translate-y-0.5 disabled:opacity-60">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Confirmar
      </button>
      <div className="mt-4 flex items-center justify-between text-xs">
        <button type="button" data-testid="otp-back" onClick={onBack} className="inline-flex items-center gap-1 text-slate-400 hover:text-white"><ArrowLeft className="h-3.5 w-3.5" /> Voltar</button>
        <button type="button" data-testid="otp-resend" onClick={resend} disabled={wait > 0} className="text-sky-300 hover:text-sky-200 disabled:text-slate-500">{wait > 0 ? `Reenviar em ${wait}s` : "Reenviar código"}</button>
      </div>
    </form>
  );
};
